import { t } from '@avalara/bat-apps-shared/i18n';
import { SDialog } from '@avalara/skylab-sdk/react';
import { useSelector } from 'react-redux';

import type { OffRampType } from '../../../../types/prequal-questionnaire';

import { useAppDispatch } from '../../hooks/use-app-dispatch';
import { exitQuestionnaire } from '../../lib/side-effects/prequal-questionnaire';
import { selectState } from '../../selectors';
import { getCtaUrlWithCampaignId } from '../helpers/prequal-questionnaire';

const dialogId = 'question.off-ramp-dialog';

type Props = {
  modalData: OffRampType;
  setOffRampModal: (offRamp: null) => void;
};

const OffRampModal = ({ modalData: { content, id }, setOffRampModal }: Props) => {
  const dispatch = useAppDispatch();
  const {
    questionnaire: { config },
  } = useSelector(selectState);
  const campaignId = config?.campaignId || '';
  const ctaUrl = getCtaUrlWithCampaignId(campaignId, content.actionButtonUrl);

  return (
    <SDialog id={dialogId} open={true} onS-dismiss={() => setOffRampModal(null)}>
      <div slot='header'>{content.heading}</div>
      <div slot='body' style={{ maxWidth: '600px' }}>
        {content.body}
      </div>
      <div slot='footer'>
        <button
          type='button'
          className='secondary pad-top-none pad-bottom-none margin-right-sm'
          onClick={() => setOffRampModal(null)}
          data-ref='qualification.offRampModal.backButton'
        >
          {t('client.buttons.back')}
        </button>
        <button
          type='button'
          className='primary'
          data-ref='qualification.offRampModal.actionLink'
          onClick={() => dispatch(exitQuestionnaire(ctaUrl, id))}
        >
          {content.actionButtonText}
        </button>
      </div>
    </SDialog>
  );
};

export default OffRampModal;
